// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__2Vlbr","subheader":"ReorderModal_subheader__3gBI6","listWrap":"ReorderModal_listWrap__1OS3o"};